/* RESON - free White pair, for email clickers only (EDM promo).

   Config is published by sections/promo-free-white.liquid, which only ever
   publishes a variant priced 0. If the promo product is set to Draft this
   file still loads but window.RESON.freePlugs is undefined, so every path
   below is inert except the one that cleans a stale gift line out of the
   cart - which is what we want when the promo ends. */
(function () {
  var CFG = (window.RESON && window.RESON.freePlugs) || null;

  /* Captured at load. The interceptor further down re-runs reconcile() after
     cart writes made by code that is not the theme (GemPages landing pages
     post straight to /cart/add.js and never fire the theme's render event).
     Our own writes go through this reference rather than window.fetch, so
     they do not re-enter the interceptor.

     This MUST stay a closure variable. Hanging it off window.fetch and
     reading it back at call time reads whichever wrapper is installed by
     then - Shopify's shop_events_listener wraps fetch after this file runs,
     so the property is gone and every intercepted call throws. */
  var rawFetch = window.fetch.bind(window);

  var OPTOUT = 'reson:giftOptOut';
  var FLAG = 'reson:freePlugsEligible';
  var TTL_MS = 14 * 24 * 60 * 60 * 1000;
  var busy = false;
  var again = false;

  /* ---- Who this promo is for -------------------------------------------
     The gift is for people who came from the campaign, not for all storefront
     traffic - paid and organic orders were going to happen anyway, and giving
     every one of them a 52.99 pair is the whole margin. Landing on any page
     with ?freegift=1 flags the visitor for TTL_MS so they keep the offer while
     they browse, compare, and come back later in the week.

     localStorage first (survives the tab closing), sessionStorage as the
     fallback for private windows and browsers that refuse storage. */
  function markEligible() {
    if (!/[?&]freegift=1(?:&|$)/.test(window.location.search)) return;
    try { localStorage.setItem(FLAG, String(Date.now() + TTL_MS)); } catch (e) {}
    try { sessionStorage.setItem(FLAG, '1'); } catch (e) {}
  }

  function eligible() {
    try {
      var until = parseInt(localStorage.getItem(FLAG) || '0', 10);
      if (until && Date.now() < until) return true;
      if (until) localStorage.removeItem(FLAG);
    } catch (e) {}
    try { return sessionStorage.getItem(FLAG) === '1'; } catch (e) {}
    return false;
  }

  function optedOut() {
    try { return !!sessionStorage.getItem(OPTOUT); } catch (e) { return false; }
  }
  function clearOptOut() {
    try { sessionStorage.removeItem(OPTOUT); } catch (e) {}
  }

  function post(url, body) {
    return rawFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* A cart qualifies on anything the shopper is actually paying for. Lines
     priced 0 are excluded on purpose: without that, this gift would keep
     itself alive in an otherwise empty cart, and any other free gift would
     do the same for it. Shipping protection is excluded for the same reason
     - it is added automatically, so a cart holding only protection is still
     an empty cart as far as this promo is concerned. */
  function qualifies(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (CFG && it.variant_id === CFG.variant) continue;
      if (!it.price) continue;
      if (CFG && CFG.exclude && CFG.exclude.indexOf(it.handle) !== -1) continue;
      return true;
    }
    return false;
  }

  /* Every line holding the gift variant, not just the first. Shopify keys a
     line by variant AND line properties, so a gift added by this script
     (which stamps _freegift) and one added by a bare /cart/VARIANT:1
     permalink are two separate lines of the same variant. Collapsing only
     the first left the shopper with two free pairs to ship - measured. */
  function giftLines(cart) {
    var out = [];
    if (!CFG) return out;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === CFG.variant) out.push(cart.items[i]);
    }
    return out;
  }

  function setQty(key, qty) {
    return post('/cart/change.js', { id: key, quantity: qty });
  }

  /* Sequential, not Promise.all: /cart/change.js is not safe to run
     concurrently against the same cart - parallel writes race and one
     silently wins. */
  function setQtySeries(pairs) {
    return pairs.reduce(function (chain, p) {
      return chain.then(function () { return setQty(p.key, p.qty); });
    }, Promise.resolve());
  }

  function redraw() {
    if (window.RESONCart && window.RESONCart.refresh) {
      try { return Promise.resolve(window.RESONCart.refresh()).catch(function () {}); }
      catch (e) { return Promise.resolve(); }
    }
    return Promise.resolve();
  }

  function reconcile() {
    if (busy) { again = true; return Promise.resolve(); }
    busy = true;
    return rawFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lines = giftLines(cart);
        var ok = CFG ? qualifies(cart) : false;

        if (!ok) {
          clearOptOut();
          if (!lines.length) return null;
          return setQtySeries(lines.map(function (l) { return { key: l.key, qty: 0 }; })).then(redraw);
        }

        if (!lines.length) {
          /* Eligibility gates ADDING only - see below. */
          if (!eligible() || optedOut()) return null;
          return post('/cart/add.js', {
            items: [{ id: CFG.variant, quantity: 1, properties: { _freegift: CFG.note } }]
          }).then(redraw);
        }

        /* A gift already in the cart is never pulled for failing the
           eligibility check, only for the cart no longer qualifying. Storage
           can be cleared or blocked mid-visit, and silently confiscating a
           gift the shopper has already been shown is worse than occasionally
           honouring one we can no longer prove was earned.

           One per order: keep the first line at quantity 1, drop duplicates. */
        var fixes = [];
        if (lines[0].quantity !== 1) fixes.push({ key: lines[0].key, qty: 1 });
        for (var i = 1; i < lines.length; i++) fixes.push({ key: lines[i].key, qty: 0 });
        if (!fixes.length) return null;
        return setQtySeries(fixes).then(redraw);
      })
      .catch(function (e) { console.warn('[reson-freeplugs]', e); })
      .then(function () {
        busy = false;
        if (again) { again = false; return reconcile(); }
      });
  }

  var wrapped = function (input, init) {
    var url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
    var p = rawFetch.apply(window, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      try { p.then(function () { setTimeout(reconcile, 200); }, function () {}); } catch (e) {}
    }
    return p;
  };
  window.fetch = wrapped;

  markEligible();

  document.addEventListener('reson:cart:rendered', function () { reconcile(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) reconcile(); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reconcile(); });
  } else {
    reconcile();
  }
})();